export const libraryConsentAuthorityAnswer = (value) => {
  const accepted = typeof value === "object" && value !== null
    ? (value.agreed ?? value.accepted)
    : value;
  const answer = { accepted: accepted === true };
  if (
    value
    && typeof value === "object"
    && value.selected_value !== undefined
    && value.selected_value !== null
    && value.selected_value !== ""
  ) {
    answer.selected_value = value.selected_value;
  }
  return answer;
};

export const hasSelectedLibraryConsentAnswer = (answer) => Boolean(
  answer
  && typeof answer === "object"
  && (
    answer.accepted === true
    || answer.selected_value !== undefined
  )
);
